import { render } from "./Company.vue?vue&type=template&id=fd01dbda&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"

import "@/assets/scss/_merchant-store-company.scss?vue&type=style&index=0&id=fd01dbda&lang=scss&scoped=true"
import "./Company.vue?vue&type=style&index=1&id=fd01dbda&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd01dbda"]])

export default __exports__